import quantityId from '../enums/quantityId.js';
import Quantity from '../entities/quantity.js';
import Unit from '../entities/unit.js';

const volume = new Quantity(
    quantityId.VOLUME,
    'Volume'
);

volume.registerUnit(
    new Unit(
        'l', 1000, 'litre', [
            'l'
        ]
    )
);

volume.registerUnit(
    new Unit(
        'usgal', 264.20079260238, 'US Gallons', [
            'gal'
        ]
    )
);

volume.registerUnit(
    new Unit(
        'm3', 264.20079260238, 'cubic metre', [
            "m³", "m^3"
        ]
    )
);

volume.registerUnit(
    new Unit(
        'ft3', 35.314475403468, 'cubic feet', [
            "ft³", "ft^3", "'³", "′³", "'^3", "′^3"
        ]
    )
);

export default volume;